import styled from 'styled-components';
import { Box, themedColor } from '@lemonade-hq/cdk';

const Container = styled(Box)`
  position: relative;
`;

const StallBubble = styled(Box)`
  position: absolute;
  border-radius: 50%;
  opacity: 0.2;
  background-color: ${themedColor('primary')};
`;

export default function Giveback2020Voters({ t, ...props }) {
  return (
    <Container {...props}>
      {t === 1 && (
        <StallBubble width={[14.5, 14.5, 28]} height={[14.5, 14.5, 28]} top={[114, 114, 78]} left={[45, 45, 90]} />
      )}
      <svg
        style={{ width: '100%' }}
        width="586px"
        height="303px"
        viewBox="0 0 586 303"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-98.000000, -10.000000)" fill="#ececec">
            <g transform="translate(98.000000, 10.000000)">
              <g transform="translate(1.000000, 0.000000)">
                <circle cx="14.5" cy="14.5" r="14.5" />
                <circle cx="145.5" cy="14.5" r="14.5" />
                <circle cx="58.5" cy="14.5" r="14.5" />
                <circle cx="189.5" cy="14.5" r="14.5" />
                <circle cx="101.5" cy="14.5" r="14.5" />
                <circle cx="233.5" cy="14.5" r="14.5" />
                <rect id="Rectangle" x="261" y="0" width="322" height="29" rx="14.5" />
              </g>
              <g transform="translate(1.000000, 78.000000)">
                <circle cx="14.5" cy="14.5" r="14.5" />
                <circle cx="145.5" cy="14.5" r="14.5" />
                <circle cx="58.5" cy="14.5" r="14.5" />
                <circle cx="189.5" cy="14.5" r="14.5" />
                <circle cx="233.5" cy="14.5" r="14.5" />
                <rect id="Rectangle-Copy-3" x="261" y="0" width="322" height="29" rx="14.5" />
              </g>
              <g transform="translate(25.000000, 39.000000)">
                <circle cx="101.5" cy="14.5" r="14.5" />
                <circle cx="14.5" cy="14.5" r="14.5" />
                <circle cx="145.5" cy="14.5" r="14.5" />
                <circle cx="58.5" cy="14.5" r="14.5" />
                <circle cx="189.5" cy="14.5" r="14.5" />
                <rect id="Rectangle-Copy-2" x="237" y="0" width="322" height="29" rx="14.5" />
              </g>
              <g transform="translate(25.000000, 117.000000)">
                <circle cx="101.5" cy="14.5" r="14.5" />
                <circle cx="14.5" cy="14.5" r="14.5" />
                <circle cx="145.5" cy="14.5" r="14.5" />
                <circle cx="58.5" cy="14.5" r="14.5" />
                <circle cx="189.5" cy="14.5" r="14.5" />
                <rect id="Rectangle-Copy-4" x="239" y="0" width="322" height="29" rx="14.5" />
              </g>
              <rect id="Rectangle-Copy-5" x="0.5" y="157" width="585" height="29" rx="14.5" />
              <rect id="Rectangle-Copy-6" x="0.5" y="235" width="585" height="29" rx="14.5" />
              <rect id="Rectangle-Copy-7" x="0.5" y="196" width="585" height="29" rx="14.5" />
              <rect id="Rectangle-Copy-8" x="0.5" y="274" width="585" height="29" rx="14.5" />
            </g>
          </g>
        </g>
      </svg>
    </Container>
  );
}
